import React from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Dashboard } from "./SidebarIcons/Dashboard";
import { User } from "./SidebarIcons/User";
import { AllUsers } from "./SidebarIcons/AllUsers";
import { AllBusiness } from "./SidebarIcons/AllBusiness";
import { Link, useLocation } from "react-router-dom";
import { FishEd } from "./SidebarIcons/FishEd";
import { AllFishEd } from "./SidebarIcons/AllFishEd";
import { Content } from "./SidebarIcons/Content";
import { TermsAndConditions } from "./SidebarIcons/TermsAndConditions";
import { PrivacyPolicy } from "./SidebarIcons/PrivacyPolicy";
import { AboutUs } from "./SidebarIcons/AboutUs";
import { Specie } from "./SidebarIcons/Specie";
import { AllSpecies } from "./SidebarIcons/AllSpecies";
import { PointTable as PointTableIcon } from "./SidebarIcons/PointTable";
import { Lake } from "./SidebarIcons/Lake";
import { AllLakes } from "./SidebarIcons/AllLakes";
import { AllSeasons } from "./SidebarIcons/AllSeasons";
import { Seasons } from "./SidebarIcons/Seasons";
import { Allannouncement } from "./SidebarIcons/Allannouncement";
import { Announcement } from "./SidebarIcons/announcement";
import { Posts as PostsIcon } from "./SidebarIcons/Posts";
const SidebarPro = () => {
  const location = useLocation();
  const active = {
    dashboard: location?.pathname == "/dashboard",

    userManagement: location?.pathname == "/user-list",
    userList: location?.pathname == "/user-list",

    fishEdManagement: location?.pathname == "/fish-ed",
    fishEd: location?.pathname == "/fish-ed",

    specieManagement: location?.pathname == "/specie-list" || location.pathname == "/specie-points",
    allSpecies: location?.pathname == "/specie-list" || location.pathname == "/specie-points",

    seasonManagement: location?.pathname == "/season-list",
    allSeason: location?.pathname == "/season-list" || location?.pathname == "/players-ranking",

    announcementManagement: location?.pathname == "/announcements",
    announcements: location?.pathname == "/announcements",

    posts: location?.pathname == "/posts",

    pointTable: location?.pathname == "/point-table",

    lakesManagement: location?.pathname == "/lake-list",
    allLakes: location?.pathname == "/lake-list",

    contentManagement: location?.pathname == "/terms-and-conditions" || location.pathname == "/privacy-policy" || location.pathname == "/about-us",
    termsAndConditions: location?.pathname == "/terms-and-conditions",
    privacyPolicy: location?.pathname == "/privacy-policy",
    aboutUs: location?.pathname == "/about-us",
  };
  return (
    <div style={{ display: "flex", height: "100wh", minHeight: "100vh" }}>
      <Sidebar
        image="https://i.pinimg.com/736x/8e/6c/06/8e6c064f57f94838263d7ba9ad80f353.jpg"
        rtl={false}
        breakPoint="lg"
        backgroundColor="rgba(29, 69, 76,0.9)"
        rootStyles={{
          color: "#8ba1b7",
        }}
      >
        <div className="sidebar-header">
          <div className="logo text-center">
            <Link to="/dashboard">
              <img src="/assets/images/logo1.jpg" style={{ width: "50%", borderRadius: 10 }} alt="logo" className="img-fluid my-3" />
            </Link>
          </div>
        </div>
        <Menu
          menuItemStyles={{
            root: {
              fontSize: "13px",
              fontWeight: 400,
            },
            button: ({ level, active, disabled, open }) => {
              if (level === 0)
                return {
                  color: disabled ? "#777777" : "#8ba1b7",
                  fontWeight: active ? "600" : "normal",
                  backgroundColor: active ? "rgba(0, 69, 139,0.8)" : undefined,
                  color: open ? "#b6c8d9" : undefined,
                  "&:hover": {
                    backgroundColor: "rgba(0, 69, 139,0.8)",
                    color: "#b6c8d9",
                  },
                };
            },
            label: ({ open, active }) => ({
              fontWeight: open || active ? 600 : undefined,
            }),
          }}
          transitionDuration={500}
        >
          <Link to="/dashboard" style={{ paddingLeft: 0, color: "#8ba1b7" }}>
            <MenuItem active={active?.dashboard} icon={<Dashboard />}>
              {" "}
              Dashboard
            </MenuItem>
          </Link>
          <Link to="/user-list" style={{ paddingLeft: 0, color: "#8ba1b7" }}>
            <MenuItem active={active?.userList} icon={<AllUsers />}>
              {" "}
              Users
            </MenuItem>
          </Link>
          <Link to="/fish-ed" style={{ paddingLeft: 0, color: "#8ba1b7" }}>
            <MenuItem active={active?.fishEd} icon={<AllFishEd />}>
              {" "}
              Reel Ed
            </MenuItem>
          </Link>
          <Link to="/season-list" style={{ paddingLeft: 0, color: "#8ba1b7" }}>
            <MenuItem active={active?.allSeason} icon={<AllSeasons />}>
              {" "}
              Season
            </MenuItem>
          </Link>
          <Link to="/announcements" style={{ paddingLeft: 0, color: "#8ba1b7" }}>
            <MenuItem active={active?.announcements} icon={<Allannouncement />}>
              {" "}
              Announcements
            </MenuItem>
          </Link>
          <Link to="/specie-list" style={{ paddingLeft: 0, color: "#8ba1b7" }}>
            <MenuItem active={active?.allSpecies} icon={<AllSpecies />}>
              {" "}
              Species
            </MenuItem>
          </Link>
          <Link to="/point-table" style={{ paddingLeft: 0, color: "#8ba1b7" }}>
            <MenuItem active={active?.pointTable} icon={<PointTableIcon />}>
              {" "}
              Point Table
            </MenuItem>
          </Link>
          <Link to="/lake-list" style={{ paddingLeft: 0, color: "#8ba1b7" }}>
            <MenuItem active={active?.allLakes} icon={<AllLakes />}>
              {" "}
              Lake Stats
            </MenuItem>
          </Link>
          <Link to="/posts" style={{ paddingLeft: 0, color: "#8ba1b7" }}>
            <MenuItem active={active?.posts} icon={<PostsIcon />}>
              {" "}
              Posts
            </MenuItem>
          </Link>
          {/* <SubMenu SubMenuExpandIcon defaultOpen={active?.userManagement} active={active?.userManagement} icon={<User />} label="Users Management" >
                        <MenuItem component={<Link to="/user-list" />} active={active?.userList} icon={<AllUsers />} rootStyles={{
                            backgroundColor: active?.userList ? "rgba(0, 69, 139,1)" : '#1D454C',
                            fontSize: '15px',
                        }}> All Users </MenuItem>
                    </SubMenu>
                    <SubMenu SubMenuExpandIcon defaultOpen={active?.fishEdManagement} active={active?.fishEdManagement} icon={<FishEd />} label="Reel Ed Management" >
                        <MenuItem component={<Link to="/fish-ed" />} active={active?.fishEd} icon={<AllFishEd />} rootStyles={{
                            backgroundColor: active?.fishEd ? "rgba(0, 69, 139,1)" : '#1D454C',
                            fontSize: '15px',
                        }}> All Reel Ed </MenuItem>
                    </SubMenu>
                    <SubMenu SubMenuExpandIcon defaultOpen={active?.seasonManagement} active={active?.seasonManagement} icon={<Seasons />} label="Season Management" >
                        <MenuItem component={<Link to="/season-list" />} active={active?.allSeason} icon={<AllSeasons />} rootStyles={{
                            backgroundColor: active?.allSeason ? "rgba(0, 69, 139,1)" : '#1D454C',
                            fontSize: '15px',
                        }}> All Season </MenuItem>
                    </SubMenu>
                    <SubMenu SubMenuExpandIcon defaultOpen={active?.announcementManagement} active={active?.announcementManagement} icon={<Announcement />} label="Announcements" >
                        <MenuItem component={<Link to="/announcements" />} active={active?.announcements} icon={<Allannouncement />} rootStyles={{
                            backgroundColor: active?.announcements ? "rgba(0, 69, 139,1)" : '#1D454C',
                            fontSize: '15px',
                        }}> Announcement </MenuItem>
                    </SubMenu>
                    <SubMenu defaultOpen={active?.specieManagement} active={active?.specieManagement} icon={<Specie />} label="Species Management" >
                        <MenuItem component={<Link to="/specie-list" />} active={active?.allSpecies} icon={<AllSpecies />} rootStyles={{
                            backgroundColor: active?.allSpecies ? "rgba(0, 69, 139,1)" : '#1D454C',
                            fontSize: '15px',
                        }}> All Species </MenuItem>
                    </SubMenu>
                    <SubMenu defaultOpen={active?.lakesManagement} active={active?.lakesManagement} icon={<Lake />} label="Lakes Management" >
                        <MenuItem component={<Link to="/lake-list" />} active={active?.allLakes} icon={<AllLakes />} rootStyles={{
                            backgroundColor: active?.allLakes ? "rgba(0, 69, 139,1)" : '#1D454C',
                            fontSize: '15px',
                        }}> All Lakes </MenuItem>
                    </SubMenu> */}
          <SubMenu defaultOpen={active?.contentManagement} active={active?.contentManagement} icon={<Content />} label="Content Management">
            <MenuItem
              component={<Link to="/terms-and-conditions" />}
              active={active?.termsAndConditions}
              icon={<TermsAndConditions />}
              rootStyles={{
                backgroundColor: active?.termsAndConditions ? "rgba(0, 69, 139,1)" : "#1D454C",
                fontSize: "15px",
              }}
            >
              {" "}
              Terms & Conditions{" "}
            </MenuItem>
            <MenuItem
              component={<Link to="/privacy-policy" />}
              active={active?.privacyPolicy}
              icon={<PrivacyPolicy />}
              rootStyles={{
                backgroundColor: active?.privacyPolicy ? "rgba(0, 69, 139,1)" : "#1D454C",
                fontSize: "15px",
              }}
            >
              {" "}
              Privacy Policy{" "}
            </MenuItem>
            <MenuItem
              component={<Link to="/about-us" />}
              active={active?.privacyPolicy}
              icon={<AboutUs />}
              rootStyles={{
                backgroundColor: active?.aboutUs ? "rgba(0, 69, 139,1)" : "#1D454C",
                fontSize: "15px",
              }}
            >
              {" "}
              About Us{" "}
            </MenuItem>
          </SubMenu>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default SidebarPro;
